import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 20 11",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.751 0.389 C 9.715 0.399,9.648 0.431,9.601 0.459 C 9.441 0.557,0.731 9.280,0.657 9.417 C 0.557 9.603,0.557 9.962,0.657 10.152 C 0.740 10.309,0.909 10.484,1.047 10.557 C 1.185 10.629,1.503 10.650,1.691 10.600 C 1.841 10.560,2.084 10.324,5.925 6.487 L 10.000 2.417 14.075 6.487 C 17.916 10.324,18.159 10.560,18.309 10.600 C 18.497 10.650,18.815 10.629,18.953 10.557 C 19.091 10.484,19.260 10.309,19.343 10.152 C 19.443 9.962,19.443 9.603,19.343 9.417 C 19.266 9.273,10.556 0.556,10.384 0.450 C 10.285 0.388,9.888 0.350,9.751 0.389 ",
		stroke: "none",
		fillRule: "evenodd"
	})
});
export default SvgCaretUp;
